export default "__VITE_ASSET__CpmhYVtw__"